<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M3 7l9 6 9-6" />
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconMail',
  props: {
    size: { type: [String, Number], default: 42 },
    strokeWidth: { type: [String, Number], default: 2.3 },
  },
};
</script>
